// Server xato kodlari va ularning foydalanuvchiga tushunarli matni.
// Baza xatoni "KOD: tafsilot" ko'rinishida beradi; klient kodni ajratib, shu yerdan matn oladi.

export class ApiError extends Error {
  readonly code: string;
  readonly status: number;
  readonly detail: string | undefined;

  constructor(code: string, status: number, detail?: string) {
    super(errorText(code, detail));
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
    this.detail = detail;
  }
}

const TEXT: Record<string, string> = {
  NETWORK: 'Internet aloqasi yo‘q yoki server javob bermadi. Qayta urinib ko‘ring.',
  INVALID_CREDENTIALS: 'Login yoki parol noto‘g‘ri.',
  SESSION_EXPIRED: 'Kirish muddati tugadi. Qaytadan kiring.',
  UNAUTHORIZED: 'Avval tizimga kiring.',
  FORBIDDEN: 'Bu amal uchun ruxsat yo‘q.',
  BAD_REQUEST: 'So‘rov noto‘g‘ri tuzilgan.',
  SERVER_ERROR: 'Serverda xato yuz berdi. Birozdan keyin urinib ko‘ring.',
  REFERENCE_INVALID: 'Bog‘langan yozuv topilmadi yoki boshqa restoranga tegishli.',
  DUPLICATE: 'Bunday yozuv allaqachon bor.',

  TENANT_NOT_FOUND: 'Restoran topilmadi.',
  TENANT_INACTIVE: 'Restoran to‘xtatilgan yoki o‘chirilgan.',
  PLAN_NOT_FOUND: 'Tarif topilmadi yoki faol emas.',
  PLAN_LIMIT: 'Yangi tarif limitlari restorandagi joriy holatga sig‘maydi.',
  PHONE_INVALID: 'Telefon raqami noto‘g‘ri (+998 XX XXX XX XX).',
  PASSWORD_INVALID: 'Parol 8–72 belgidan iborat bo‘lishi kerak.',
  PIN_INVALID: 'PIN 6 ta raqamdan iborat bo‘lishi kerak.',
  TRIAL_DAYS_INVALID: 'Sinov muddati 0–180 kun bo‘lishi kerak.',
  OWNER_USER_CONFLICT: 'Bu raqam platforma xodimi yoki qurilmaga tegishli.',
  OWNER_NOT_FOUND: 'Restoran egasi topilmadi.',
  AUTH_CREATE_FAILED: 'Ega hisobini yaratib bo‘lmadi.',
  PROVISION_FAILED: 'Restoranni yaratib bo‘lmadi.',
  SPEC_VERSION: 'Panel eskirgan — sahifani yangilang.',
  COPY_SOURCE_NOT_FOUND: 'Nusxa olinadigan restoran topilmadi.',
  CONTENT_MODE_INVALID: 'Menyu manbasi noto‘g‘ri tanlangan.',
  MENU_INVALID: 'Menyu ma’lumotida xato bor.',
  HALL_MODULE_OFF: 'Stollar uchun “Zal va stollar” bo‘limi yoqilishi kerak.',
  OWNER_ROLE_REQUIRED: 'Ega roli majburiy.',
  ROLE_INVALID: 'Rolda noma’lum qurilma turi bor.',
  LIMIT_NOT_SUPPORTED: 'Bu huquqqa limit qo‘yib bo‘lmaydi.',

  MODULE_UNKNOWN: 'Noma’lum bo‘lim.',
  MODULE_NOT_AVAILABLE: 'Bu bo‘lim hali tayyor emas.',
  MODULE_NOT_IN_PLAN: 'Bu bo‘lim restoran tarifida yo‘q.',
  MODULE_REQUIRES: 'Avval bog‘liq bo‘limni yoqing.',
  MODULE_REQUIRED_BY: 'Bu bo‘limga boshqa yoqilgan bo‘lim tayanadi — avval o‘shani o‘chiring.',
  MODULE_SALES_REQUIRED: '“Savdo va smena” bo‘limi har doim yoqiq bo‘ladi.',
  MODULE_LOCKED: 'Bu bo‘limni platforma qulflagan.',

  SETTING_UNKNOWN: 'Noma’lum sozlama.',
  SETTING_INVALID: 'Sozlama qiymati noto‘g‘ri.',
  SETTING_PROTECTED: 'Bu tizimli sozlama — faqat platforma o‘zgartiradi.',
  SETTING_LOCKED: 'Bu sozlamani platforma qulflagan.',
  CONFIRM_REQUIRED: 'Bu muhim sozlama — o‘zgartirishni tasdiqlang.',

  FIELD_NOT_EDITABLE: 'Bu maydonni bu yerda o‘zgartirib bo‘lmaydi.',
  STATUS_INVALID: 'Holat noto‘g‘ri.',
  REASON_REQUIRED: 'Sababini yozing (kamida 3 belgi).',
  DATE_INVALID: 'Sana noto‘g‘ri (bir yildan uzoq bo‘lmasin).',
  MODE_INVALID: 'Rejim noto‘g‘ri.',
  DURATION_INVALID: 'Muddat 5–240 daqiqa bo‘lishi kerak.',

  BRANCH_NOT_FOUND: 'Filial topilmadi.',
  KIND_INVALID: 'Qurilma turi noto‘g‘ri.',
  NAME_INVALID: 'Nom 1–60 belgi bo‘lishi kerak.',
  DEVICE_LIMIT: 'Tarifdagi bu turdagi qurilmalar soni to‘lgan. Eski qurilma o‘rniga qo‘shing yoki ONE POS orqali tarifni kengaytiring.',
  DEVICE_MODULE_OFF: 'Bu qurilma turi uchun kerakli bo‘lim yoqilmagan.',
  TERMINAL_NOT_FOUND: 'Qurilma topilmadi.',
  CODE_INVALID: 'Kod noto‘g‘ri yoki muddati tugagan.',

  // Boshqaruv (ega, menejer, kassadagi xodim)
  NOT_FOUND: 'Yozuv topilmadi yoki boshqa restoranga tegishli.',
  SESSION_REQUIRED: 'Avval PIN bilan kiring.',
  SESSION_INVALID: 'Kirish muddati tugadi — PIN’ni qayta kiriting.',
  OWNER_ONLY: 'Bu amalni faqat restoran egasi bajaradi.',
  READ_ONLY: 'Faqat ko‘rish rejimi: o‘zgartirib bo‘lmaydi.',
  SUPPORT_FORBIDDEN: 'ONE POS yordami pul, sklad va kirish ma’lumotlariga tegmaydi — buni restoran egasi bajaradi.',
  GRANT_DENIED: 'O‘zingizda yo‘q huquqni (yoki limitdan kattasini) bera olmaysiz.',
  SELF_EDIT: 'O‘z rolingiz yoki huquqlaringizni o‘zgartira olmaysiz.',
  SELF_DEACTIVATE: 'O‘zingizni (yoki ishlab turgan qurilmani) o‘chira olmaysiz.',
  LAST_OWNER: 'Restoranda kamida bitta ega qolishi kerak.',
  ROLE_LOCKED: 'Ega roli o‘zgartirilmaydi.',
  ROLE_IN_USE: 'Bu rolda xodimlar bor — avval ularni boshqa rolga o‘tkazing.',
  ROLE_NOT_FOUND: 'Rol topilmadi.',
  PIN_LENGTH: 'PIN uzunligi rolga mos emas.',
  PIN_LENGTH_INVALID: 'PIN uzunligi 4 yoki 6 bo‘lishi kerak.',
  PIN_LENGTH_LOCKED: 'Rolda xodimlar bor — PIN uzunligini o‘zgartirib bo‘lmaydi.',
  PIN_TAKEN: 'Bu PIN band — boshqasini tanlang.',
  STAFF_LIMIT: 'Tarifdagi xodimlar soni tugagan.',
  CHANNEL_NOT_FOUND: 'Savdo kanali topilmadi.',
  CHANNEL_INACTIVE: 'Bu savdo kanali o‘chirilgan. Kassani yangilang.',
  CHANNEL_PRODUCT_OFF: 'Bu mahsulot shu kanalda sotilmaydi',
  EXTERNAL_NO_DUPLICATE: 'Bu agregator raqami bilan buyurtma allaqachon bor',
  CHANNEL_LIMIT: 'Ko‘pi bilan 20 ta savdo kanali.',
  API_KEY_LIMIT: 'Ko‘pi bilan 10 ta faol API kaliti. Keraksizini bekor qiling.',
  TEXT_TOO_LONG: 'Matn juda uzun: tarkib 500 belgigacha, og‘irlik 40 belgigacha.',
  CHANNEL_REQUIRED: 'Buyurtma qabul qiladigan kalitga savdo kanalini tanlang (masalan, Uzum Tezkor).',
  API_SCOPE_DENIED: 'Bu kalitga bu amal ruxsat etilmagan.',
  RESTAURANT_CLOSED: 'Restoran yopiq: smena ochilmagan.',
  PRODUCT_UNAVAILABLE: 'Mahsulot tugagan.',
  MODIFIER_NOT_ALLOWED: 'Bu qo‘shimcha shu mahsulotga tegishli emas.',
  MODIFIER_COUNT: 'Qo‘shimchalar soni noto‘g‘ri.',
  ORDER_ALREADY_ACCEPTED: 'Buyurtma allaqachon qabul qilingan — kerak bo‘lsa, “Buyurtmalar”dan bekor qiling.',
  ORDER_ALREADY_SERVED: 'Buyurtma allaqachon berilgan.',
  API_KEY_INVALID: 'API kaliti noto‘g‘ri.',
  API_KEY_REVOKED: 'Bu kalit bekor qilingan — yangisini yarating.',
  API_TOKEN_INVALID: 'API tokeni noto‘g‘ri — agregator yangi token olishi kerak.',
  API_TOKEN_EXPIRED: 'API tokeni muddati o‘tgan — agregator yangi token olishi kerak.',
  API_CLIENT_INVALID: 'Client ID kalitga mos emas.',
  IP_INVALID: 'IP manzil noto‘g‘ri. Masalan: 185.1.2.3 yoki 10.0.0.0/8.',
  FORECAST_LIMIT: 'Ko‘pi bilan 10 ta reja saqlanadi. Keraksizini o‘chiring.',
  FIXED_COST_INVALID: 'Doimiy xarajat noto‘g‘ri: summa, foiz (0–50%), davr yoki to‘lov kunini tekshiring.',
  FIXED_COST_LIMIT: 'Ko‘pi bilan 50 ta doimiy xarajat kiritiladi.',
  FIXED_COST_PAID: 'Bu davr uchun to‘lov allaqachon yozilgan. Xato bo‘lsa, Moliya bo‘limida bekor qiling.',
  CATEGORY_REQUIRED: 'Kategoriyani tanlang.',
  CATEGORY_INVALID: 'Turkum noto‘g‘ri.',
  PRICE_INVALID: 'Narx noto‘g‘ri.',
  UNIT_INVALID: 'O‘lchov birligi noto‘g‘ri.',
  UNIT_LOCKED: 'Retseptda ishlatilgan xom ashyo birligini o‘zgartirib bo‘lmaydi.',
  MATERIAL_IN_RECIPE: 'Bu xom ashyo retseptlarda bor — avval retseptdan olib tashlang.',
  QTY_INVALID: 'Miqdor noto‘g‘ri.',
  SEATS_INVALID: 'O‘rindiqlar soni noto‘g‘ri.',
  SELECT_RANGE_INVALID: 'Tanlash soni noto‘g‘ri (eng kami eng ko‘pidan katta bo‘lmasin).',
  TARGET_INVALID: 'Noto‘g‘ri bog‘lanish.',
  TYPE_INVALID: 'Turi noto‘g‘ri.',
  RANGE_INVALID: 'Sana oralig‘i noto‘g‘ri (bir yildan oshmasin).',
  OWNER_USER_NOT_FOUND: 'Ega hisobi topilmadi.',

  // Kirish (Q-021)
  LOGIN_INVALID: 'Login yoki parol noto‘g‘ri.',
  LOGIN_LOCKED: 'Ko‘p marta xato kiritildi — login 15 daqiqaga bloklandi.',
  LOGIN_FORMAT: 'Login 3–32 belgi: lotin harflari, raqam, “-” yoki “_”.',
  LOGIN_TAKEN: 'Bu login band — boshqasini tanlang.',
  LOGIN_NOT_SET: 'Restoran logini hali berilmagan — ONE POS yordamiga murojaat qiling.',
  LOGIN_FAILED: 'Restoran logini saqlanmadi — restoran sahifasida qayta bering.',
  PASSWORD_WEAK: 'Parol juda qisqa (kamida 6 belgi, restoran paroli — 8).',
  PASSWORD_WRONG: 'Parol noto‘g‘ri.',
  PASSWORD_LOCKED: '3 marta xato parol — 60 daqiqaga bloklandi. Ega yoki ONE POS yordami ochib beradi.',
  PASSWORD_REQUIRED: 'Bu rol uchun parol majburiy — uni olib tashlab bo‘lmaydi.',
  TICKET_INVALID: 'Kirish vaqti tugadi — PIN’ni qayta kiriting.',
  APPROVAL_REQUIRED: 'Yangi qurilma. Avval ega yoki menejer tasdiqlashi kerak.',
  DEVICE_NOT_APPROVED: 'Qurilma hali tasdiqlanmagan.',
  DEVICE_PENDING_LIMIT: 'Tasdiq kutayotgan qurilmalar juda ko‘p. Avval ularni tasdiqlang yoki o‘chiring.',
  PANEL_FORBIDDEN: 'Sizda boshqaruv paneliga ruxsat yo‘q.',
  BRANCH_INVALID: 'Filial noto‘g‘ri.',

  // Mahsulot rasmi
  URL_INVALID: 'Rasm manzili noto‘g‘ri.',
  IMPORT_FORMAT: 'Bu fayl fast eksporti emas yoki buzilgan. Eksport so‘rovini fast bazasida qayta ishga tushiring.',
  IMPORT_NOT_EMPTY: 'Restoranda menyu yoki xom ashyo allaqachon bor — import faqat bo‘sh restoranga qilinadi.',
  IMPORT_DRY_RUN: 'Sinov tugadi — bazaga hech narsa yozilmadi.',
  IMAGE_INVALID: 'Rasm o‘qilmadi — JPG, PNG yoki WEBP tanlang.',
  IMAGE_TOO_LARGE: 'Rasm juda katta (1 MB gacha).',
  UPLOAD_FAILED: 'Rasm yuklanmadi — qayta urinib ko‘ring.',

  // Tarif (Q-022)
  PLATFORM_ONLY: 'Bu bo‘limni faqat ONE POS ulaydi — tarifni o‘zgartirish uchun murojaat qiling.',
  OWNER_EXISTS: 'Restoranda faqat bitta ega bo‘ladi.',
  REPLACE_INVALID: 'Almashtiriladigan qurilma topilmadi yoki turi boshqa.',
  LIMIT_UNKNOWN: 'Noma’lum limit.',
  LIMIT_INVALID: 'Limit 0 dan 999 gacha butun son bo‘lishi kerak.',

  // Kassa
  TERMINAL_NOT_REGISTERED: 'Bu qurilma ulanmagan yoki uzilgan. Qayta ulang.',
  DEVICE_NOT_ALLOWED: 'Bu xodim yoki amal shu qurilmada ruxsat etilmagan.',
  INVALID_PIN: 'PIN noto‘g‘ri.',
  STAFF_LOCKED: 'Bu xodim vaqtincha bloklangan.',
  LOCKED: 'Ko‘p marta xato — bir oz kuting.',
  STAFF_INVALID: 'Xodim topilmadi yoki bu qurilmada ishlay olmaydi.',
  LIMIT_EXCEEDED: 'Sizning limitingizdan oshib ketdi.',
  CLIENT_ID_REQUIRED: 'Kassa ilovasi eskirgan — sahifani yangilang.',
  SHIFT_REQUIRED: 'Avval smena oching.',
  SHIFT_NOT_FOUND: 'Smena topilmadi.',
  EMPTY_ORDER: 'Savat bo‘sh.',
  ORDER_TOO_LARGE: 'Buyurtmada juda ko‘p qator.',
  ORDER_TYPE_INVALID: 'Buyurtma turi noto‘g‘ri.',
  ORDER_TYPE_DISABLED: 'Bu buyurtma turi restoranda yoqilmagan.',
  ORDER_NOT_FOUND: 'Buyurtma topilmadi.',
  ORDER_VOIDED: 'Buyurtma bekor qilingan.',
  ORDER_PAID: 'Buyurtma to‘langan — unga taom qo‘shib bo‘lmaydi.',
  ORDER_REFUNDED: 'Pul qaytarilgan buyurtmani bekor qilib bo‘lmaydi.',
  // Band stol amallari (Q-060)
  ORDER_HAS_PAYMENTS: 'Bu buyurtmaga to‘lov qilingan — uni o‘zgartirib bo‘lmaydi. Kerak bo‘lsa, pul qaytaring.',
  ITEM_NOT_FOUND: 'Taom topilmadi — buyurtmani yangilang.',
  LAST_ITEM: 'Bu buyurtmadagi oxirgi taom — butun buyurtmani bekor qiling.',
  ONLINE_REQUIRED: 'Bu amal uchun internet kerak.',
  SAME_ORDER: 'Boshqa buyurtmani tanlang.',
  MERGE_CHANNEL: 'Agregator (savdo kanali) buyurtmasini boshqasi bilan birlashtirib bo‘lmaydi.',
  SPLIT_ALL: 'Hamma taomni ajratib bo‘lmaydi — kamida bittasi shu hisobda qolsin.',
  BILL_LOCKED: 'Hisob cheki chiqarilgan — hisob qulflangan. O‘zgartirish uchun avval “Hisobni ochish”.',
  PRODUCT_NOT_FOUND: 'Mahsulot topilmadi — menyuni yangilang.',
  MODIFIER_NOT_FOUND: 'Qo‘shimcha topilmadi — menyuni yangilang.',
  // Kombo (Q-036)
  COMBO_EMPTY: 'Komboga kamida bitta mahsulot qo‘shing.',
  COMBO_TOO_LARGE: 'Kombo tarkibida ko‘pi bilan 10 ta bo‘lim bo‘ladi.',
  COMBO_NOT_COMBO: 'Bu oddiy mahsulot — uni kombo qilib bo‘lmaydi. Yangi kombo yarating.',
  COMBO_NESTED: 'Bu kombo boshqa kombo tarkibida — kombo ichida kombo bo‘lmaydi.',
  COMBO_OPTIONS_INVALID: 'Har bo‘limda bitta asosiy mahsulot bo‘lishi kerak. Almashtirish o‘chiq bo‘lsa — faqat asosiysi.',
  COMBO_QTY_INVALID: 'Soni 1 dan 20 gacha bo‘lsin.',
  COMBO_PRODUCT_INVALID: 'Kombo tarkibiga faqat menyudagi faol oddiy mahsulotni qo‘shish mumkin (bir bo‘limda bir marta).',
  COMBO_EXTRA_INVALID: 'Ustama narx noto‘g‘ri. Asosiy mahsulotda ustama bo‘lmaydi.',
  COMBO_CHOICE_INVALID: 'Kombo o‘zgargan — kassani yangilab, qaytadan tanlang.',
  COMBO_SWAP_FORBIDDEN: 'Bu kombo tarkibini almashtirishga ruxsat yo‘q.',
  COMBO_MODIFIERS_FORBIDDEN: 'Komboga qo‘shimcha qo‘shib bo‘lmaydi — tarkibini ega sozlaydi.',
  PRODUCT_IN_COMBO: 'Bu mahsulot kombo tarkibida. Avval komboni o‘zgartiring yoki arxivlang.',
  COMBO_NOT_ALLOWED: 'Komboni xodim ovqati qilib bo‘lmaydi — alohida taomni tanlang.',
  // Kirim nazorati (Q-037)
  RECEIVE_PRICE_OVER: 'Kirim narxi belgilangan chegaradan yuqori. Narxni tekshiring yoki egaga murojaat qiling.',
  RECEIPT_PRICE_DONE: 'Bu qatorning narxi allaqachon tasdiqlangan.',
  RECEIPT_PENDING: 'Avval tasdiq kutayotgan narxlarni ko‘rib chiqing.',
  RECEIPT_VOIDED: 'Bu kirim bekor qilingan.',
  RECEIPT_STOCK_USED: 'Kirimni bekor qilib bo‘lmaydi: xom ashyoning bir qismi allaqachon ishlatilgan (skladda yetarli qoldiq yo‘q).',
  TABLE_NOT_FOUND: 'Stol topilmadi.',
  DISCOUNT_INVALID: 'Chegirma summasi noto‘g‘ri.',
  NOTICE_INVALID: 'Ogohlantirish muddati 0–365 kun bo‘lishi kerak.',
  DEMO_UNAVAILABLE: 'Bu amal demo rejimida mavjud emas — haqiqiy restoranda ishlaydi.',
  PRICE_MISMATCH: 'Narxlar o‘zgargan — menyu yangilandi, summani tekshiring.',
  PAYMENT_INVALID: 'To‘lov ma’lumoti noto‘g‘ri.',
  PAYMENT_METHOD_INVALID: 'To‘lov turi noto‘g‘ri.',
  AMOUNT_INVALID: 'Summa noto‘g‘ri.',
  OVERPAID: 'To‘lov buyurtma summasidan oshib ketdi.',
  REFUND_TOO_MUCH: 'Qaytariladigan summa to‘langanidan oshib ketdi.',
  REFUND_QTY_TOO_MUCH: 'Bu taomdan buncha qaytarib bo‘lmaydi — avval qaytarilganlari hisobga olinadi. Buyurtmani yangilang.',
  REFUND_ITEMS_INVALID: 'Qaytariladigan taomlar ro‘yxati noto‘g‘ri.',

  // Sklad, moliya, xodim ovqati
  MODULE_OFF: 'Bu bo‘lim restoranda yoqilmagan.',
  SHIFT_CLOSED: 'Smena yopilgan — bu yozuvni faqat ega o‘zgartira oladi.',
  MEAL_NOT_ALLOWED: 'Bu xodimga bugun bu taom belgilanmagan.',
  ALREADY_GIVEN: 'Bugun allaqachon berilgan.',
  // Ofitsiant (Q-067)
  TABLE_OTHER_WAITER: 'Bu stol boshqa ofitsiantniki. Unga tegish uchun ruxsat kerak (“Boshqa ofitsiant stolini o‘zgartirish”) yoki stolni sizga o‘tkazishsin.',
  STAFF_NOT_FOUND: 'Xodim topilmadi yoki faol emas.',
  PAY_AT_KASSA: 'To‘lov kassada qabul qilinadi — restoran sozlamasi shunday.',
  WEIGHT_NOT_ALLOWED: 'Bu mahsulot kilogrammda sotilmaydi — menyuni yangilang.',
  WEIGHT_INVALID: 'Og‘irlik noto‘g‘ri: 1 grammdan 100 kg gacha.',
  WEIGHT_NO_MODIFIERS: 'Kilogrammlik mahsulotga qo‘shimcha qo‘shib bo‘lmaydi.',
  WEIGHT_AMOUNTS_INVALID: 'Tez summalar: 6 tagacha, har biri 100 so‘mdan katta.',
  WAITER_CASH_TOO_MUCH: 'Ofitsiantda buncha topshirilmagan naqd yo‘q. Summani tekshiring.',
  // Chekda manzil va telefon (Q-066)
  BRANCH_PHONE_INVALID: 'Telefon raqami noto‘g‘ri: raqamlar, bo‘sh joy va + - ( ) belgilari, 5 dan 15 tagacha raqam.',
  ADDRESS_TOO_LONG: 'Manzil juda uzun — 200 belgigacha.',
  // Obuna (Q-064)
  GRACE_INVALID: 'Muhlat 0 dan 60 kungacha bo‘lishi kerak.',
  METHOD_INVALID: 'To‘lov usulini tanlang.',
  MONTHS_INVALID: 'Davr 1, 3, 6 yoki 12 oy bo‘lishi kerak.',
  NOT_LAST_PAYMENT: 'Faqat oxirgi to‘lovni bekor qilish mumkin.',
  PAYMENT_NOT_FOUND: 'To‘lov topilmadi.',
  PAYMENT_VOIDED: 'Bu to‘lov allaqachon bekor qilingan.',
  PERIOD_IN_PAST: 'Bu davr allaqachon o‘tib ketgan — boshlanish sanasini tekshiring.',
  REQUEST_CONFLICT: 'So‘rov boshqa restoranga tegishli. Oynani yopib, qaytadan oching.',
};

export function errorText(code: string, detail?: string): string {
  const text = TEXT[code];
  if (text) return text;
  return detail ? `Kutilmagan xato: ${detail}` : `Kutilmagan xato (${code}).`;
}

/** "SETTING_PROTECTED: flow.x" -> "SETTING_PROTECTED" */
export function codeFromMessage(message: string | undefined): string | null {
  const m = (message ?? '').match(/^([A-Z][A-Z_]{2,})(?::|$)/);
  return m?.[1] ?? null;
}

/** Server javobidagi xatodan ApiError yasaydi (PostgREST, Auth, Edge Function) */
export function toApiError(status: number, body: unknown): ApiError {
  const b = (body && typeof body === 'object' ? body : {}) as Record<string, unknown>;
  const message = typeof b.message === 'string' ? b.message : typeof b.msg === 'string' ? b.msg : undefined;

  // Edge Function: { ok: false, error: 'KOD', detail? }
  if (typeof b.error === 'string' && /^[A-Z][A-Z_]+$/.test(b.error)) {
    return new ApiError(b.error, status, typeof b.detail === 'string' ? b.detail : undefined);
  }
  // Supabase Auth
  const authCode = typeof b.error_code === 'string' ? b.error_code : typeof b.error === 'string' ? b.error : undefined;
  if (authCode === 'invalid_credentials' || authCode === 'invalid_grant') {
    return new ApiError(status === 400 && /refresh/i.test(String(b.error_description ?? message ?? '')) ? 'SESSION_EXPIRED' : 'INVALID_CREDENTIALS', status);
  }
  if (authCode === 'refresh_token_not_found' || authCode === 'session_not_found' || authCode === 'bad_jwt') {
    return new ApiError('SESSION_EXPIRED', status);
  }
  // PostgREST / Postgres
  const pg = typeof b.code === 'string' ? b.code : undefined;
  const fromMsg = codeFromMessage(message);
  if (fromMsg) return new ApiError(fromMsg, status, message);
  if (pg === '42501') return new ApiError('FORBIDDEN', status, message);
  // Baza o'qish rejimida: obuna to'xtatilgan yoki ONE POS yordami "faqat ko'rish"
  if (pg === '25006') return new ApiError('READ_ONLY', status, message);
  if (pg === '23503') return new ApiError('REFERENCE_INVALID', status, message);
  if (pg === '23505') return new ApiError('DUPLICATE', status, message);
  if (pg === 'PGRST301' || pg === 'PGRST303') return new ApiError('SESSION_EXPIRED', status, message);
  if (status === 401) return new ApiError('UNAUTHORIZED', status, message);
  if (status === 403) return new ApiError('FORBIDDEN', status, message);
  if (status >= 500) return new ApiError('SERVER_ERROR', status, message);
  return new ApiError('BAD_REQUEST', status, message);
}
